import { SHARED_MODE, SPECIAL_MODE, CONNECTION_STATUS } from '../../context/enums';

export const LABEL_STOP_PRESOAK = 'STOP PRESOAK';
export const LABEL_INITIATE_PRESOAK = 'Initiate Presoak';

/**
 * Presoak/collaborative stop button for the Dashboard control panel.
 * Renders the collaborative stop button when isCollaborative is true,
 * otherwise renders the presoak toggle button.
 * @param {{ isCollaborative: boolean, isPresoaking: boolean, systemStatus: Object|null, connectionStatus: string, isTestMode: boolean, onPresoakClick: Function, onCollaborativeClick: Function }} props
 * @returns {JSX.Element}
 */
const PresoakOrCollaborativeButton = ({
  isCollaborative,
  isPresoaking,
  systemStatus,
  connectionStatus,
  isTestMode,
  onPresoakClick,
  onCollaborativeClick,
}) => {
  if (isCollaborative) {
    return (
      <button
        className={`presoak-button collaborative active`}
        onClick={onCollaborativeClick}
        disabled={!systemStatus || connectionStatus === CONNECTION_STATUS.DISCONNECTED}
      >
        STOP COLLABORATION
      </button>
    );
  }

  return (
    <button
      className={`presoak-button ${isPresoaking ? 'active' : ''}`}
      onClick={onPresoakClick}
      disabled={
        !systemStatus ||
        connectionStatus === CONNECTION_STATUS.DISCONNECTED ||
        systemStatus.sharedMode === SHARED_MODE.ACTIVATING ||
        systemStatus.sharedMode === SHARED_MODE.DEACTIVATING ||
        (systemStatus.sharedMode === SHARED_MODE.ON && systemStatus.specialMode === SPECIAL_MODE.NONE) ||
        (systemStatus.sharedMode === SHARED_MODE.PRIMING && systemStatus.specialMode === SPECIAL_MODE.NONE)
      }
    >
      {isPresoaking ? LABEL_STOP_PRESOAK : LABEL_INITIATE_PRESOAK}
    </button>
  );
};

export default PresoakOrCollaborativeButton;
